import {
  Analysis,
  DashboardConfigurationDependencies,
  Granularity,
} from '../../../../dashboard-config/dashboard-config.model';
import { DashboardFilter } from '../../../../filters/dashboard_filter';
import {
  DashboardStatesMultiSelectFilter,
  DashboardSubMarketSingleSelectFilter,
  DashboardWzClassesMultiSelectFilter,
} from '../../../../filters/dashboard_filter_implementations';
export const RANKING_MULTI_COLUMN_SHELL_ID = 'ranking-multi-column' as const;

export type DashboardRankingMultiColumnShell = 'wzClasses';

export interface DashboardRankingMultiColumnShellProfile {
  id: typeof RANKING_MULTI_COLUMN_SHELL_ID;
  granularityId: Granularity;
  analysisId: Analysis;
  /** The view ranks WZ classes per state, so its chart words name both. */
  chartHeadingGranularity: (filterValues: Map<string, any>) => string;
  buildGranularityFilters: (
    deps: DashboardConfigurationDependencies,
  ) => DashboardFilter<any>[];
}

export const dashboardRankingMultiColumnShellProfiles: Record<DashboardRankingMultiColumnShell, DashboardRankingMultiColumnShellProfile> = {
  wzClasses: {
    id: RANKING_MULTI_COLUMN_SHELL_ID,
    granularityId: Granularity.WzClasses,
    analysisId: Analysis.Ranking,
    chartHeadingGranularity: (fv) => `${fv.get('sub_market') ?? ''} NACH WZ-KLASSEN & BUNDESLÄNDERN`.trim(),
    buildGranularityFilters: (deps) => [
      new DashboardStatesMultiSelectFilter(deps.localDatasetsService, {
        addSumGermany: false,
      }),
      new DashboardSubMarketSingleSelectFilter(deps.localDatasetsService, {}),
      new DashboardWzClassesMultiSelectFilter(deps.localDatasetsService, {}),
    ],
  },
};
